export const assert = (test: boolean) => {
  console.assert(test);
  return test;
};
